import script from "./ImageCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageCode.vue?vue&type=script&lang=ts&setup=true"

import "./ImageCode.vue?vue&type=style&index=0&id=6cf3c2f5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf3c2f5"]])

export default __exports__